import { CDN_IMAGES } from '../../../../../constants';
import { ProductAbbreviation } from '../../../../../types/product';

export const getPromoImageByGame = (productAbbreviation: string) => {
  switch (productAbbreviation) {
    case ProductAbbreviation.LOL:
      return `${CDN_IMAGES}/one-time-plus-offer/lol-skin-chest.png`;
    case ProductAbbreviation.TFT:
      return `${CDN_IMAGES}/one-time-plus-offer/tft-egg-chest.png`;
    default:
      return null;
  }
};
